import React, { useEffect, useState } from "react";
import "../../Styles/Settings/ResponseSetting.css";
import AutoDeleteModal from "./SettingModals/AutoDeleteModal";
import open_responses_setting from "../../Assets/open_responses_setting.png";
import caret_down from "../../Assets/caret-down.png";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { createNewForm } from "../../Redux/Reducer/FormSlices";
import { useDispatch } from "react-redux";

const ResponseSetting = () => {
  const [openAutoDelete, setOpenAutoDelete] = useState(false);
  const formId = useParams().formId;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handelOpenADM = () => {
    setOpenAutoDelete(!openAutoDelete);
  };

  //open the response edting sections
  const [isOpenResponsesEditing, setOpenResponsesEditing] = useState(false);
  const [isOpenDropDown, setOpenDropDown] = useState(false);
  const valuesOfdata = [
    "1 GB",
    "2 GB",
    "3 GB",
    "4 GB",
    "5 GB",
    "7 GB",
    "8 GB",
    "9 GB",
    "10 GB",
  ];

  const defaultResponseSetting = {
    allowResponseEditing: true,
    totalFileLimit: "1 GB",
    autoDeleteResponse: false,
    autoDeleteResponseTime: { label: "Disable", date: "" },
  };

  const [responseSetting, setResponseSetting] = useState(
    defaultResponseSetting
  );

  //get form settings
  useEffect(() => {
    const fetchFormSettings = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/forms/singleFormSettings/${formId}`
        );
        if (response.data.status) {
          setResponseSetting(response.data.responseSettings);
        }
      } catch (error) {
        console.error(error);
        setResponseSetting(defaultResponseSetting);
      }
    };
    fetchFormSettings();
  }, [formId]);

  //handel submit response settingre
  const handleSubmitResponseSetting = async () => {
    const data = {
      value: responseSetting,
      type: "responseSetting",
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/forms/singleFormSetting/${formId}`,
        data
      );
      if (response.status === 200) {
        console.log(
          "44444444444444444444444444444444444444444444444444444444",
          data
        );

        dispatch(createNewForm(response.data.formDetails));
        navigate(`/create-form/${formId}/question`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handelChange = (e) => {
    const { name, value, checked, type } = e.target;
    if (type === "checkbox") {
      setResponseSetting((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else if (type === "number") {
      setResponseSetting((prevState) => ({
        ...prevState,
        [name]: parseInt(value),
      }));
    } else if (type === "select-one") {
      setResponseSetting((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handelLimtValue = (limitValue) => {
    setResponseSetting((prevState) => ({
      ...prevState,
      totalFileLimit: limitValue,
    }));
    setOpenDropDown(!isOpenDropDown);
  };
  return (
    <>
      <AutoDeleteModal
        isOpen={openAutoDelete}
        onClose={handelOpenADM}
        responseSetting={responseSetting}
        setResponseSetting={setResponseSetting}
      />
      <div className="response-setting-container">
        <div
          className="encrypt-data-container"
          onClick={() => setOpenResponsesEditing(!isOpenResponsesEditing)}
        >
          <div className="text-container-setting">
            <div className="heading-mark-details">Responses</div>
            <div className="text-des">
              Manage how responses are collected and protected
            </div>
          </div>
          <div>
            <img src={open_responses_setting} alt="open_responses_setting" />
          </div>
        </div>
        {isOpenResponsesEditing && (
          <>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="heading-mark-details">
                  Allow response editing
                </div>
                <div className="text-des">
                  Responses can be changed after being submitted
                </div>
              </div>
              <div>
                <label class="form-setting-switch">
                  <input
                    type="checkbox"
                    name="allowResponseEditing"
                    checked={responseSetting.allowResponseEditing}
                    onChange={handelChange}
                  />
                  <span class="form-setting-slider form-setting-round"></span>
                </label>
              </div>
            </div>
            <div className="fileUpload-container">
              <div className="fileUpload-container-head">FILE UPLOAD</div>
              <div className="encrypt-data-container">
                <div className="text-container-setting">
                  <div className="heading-mark-details">
                    Total size limit for all uploaded files
                  </div>
                  <div className="text-des">
                    Responses will not be accepted after the limit is
                    reached. Learn more
                  </div>
                </div>
                <div
                  className="total-file-limit-upload-btn"
                  onClick={() => setOpenDropDown(!isOpenDropDown)}
                >
                  {console.log(responseSetting)}
                  <div>{responseSetting.totalFileLimit}</div>
                  <div>
                    <img src={caret_down} alt="caret_down" />
                  </div>
                  {isOpenDropDown && (
                    <div className="list-of-Limt-value">
                      {valuesOfdata.map((value, indx) => (
                        <div
                          className="list-of-single-values"
                          onClick={() => handelLimtValue(value)}
                        >
                          {value}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="response-setting-container">
        <div
          className="encrypt-data-container"
          style={{ alignItems: "center" }}
        >
          <div className="text-container-setting">
            <div className="heading-mark-details">Auto-Delete Submissions</div>
            <div className="text-des">
              Delete form submissions after a certain period of time
            </div>
          </div>
          <button
            className={
              responseSetting.autoDeleteResponseTime.label === "Disable"
                ? "auto-delete-response"
                : "auto-delete-response-desable"
            }
            onClick={() => setOpenAutoDelete(!openAutoDelete)}
          >
            {responseSetting.autoDeleteResponseTime.label === "Disable"
              ? "Enable"
              : "Disable"}
          </button>
        </div>
        <div className="encrypt-data-container">
          <div className="text-container-setting">
            <div className=".heading-mark-details">Unique Submission</div>
            <div className="text-des">
              Use cookies or IP address to prevent multiple form submissions
            </div>
          </div>
          <div></div>
        </div>
        <div className="encrypt-data-container">
          <div className="text-container-setting">
            <div className=".heading-mark-details">
              Disable auto-save for all respondents
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <hr />
      <div
        style={{ display: "flex", justifyContent: "end", paddingRight: "2rem" }}
      >
        <button
          className="save-btn-form-response-setting"
          onClick={handleSubmitResponseSetting}
        >
          Save
        </button>
      </div>
    </>
  );
};

export default ResponseSetting;
